import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { getResponseMessage } from '../../../../../../utils/utils';
import { deleteOfferImport } from '../../../../../../crud/offer.crud';

export const useDeleteImport = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingDelete, setLoading] = useState(false);
  const [successDelete, setSuccess] = useState(false);

  const fetchDelete = useCallback(async (id: number) => {
    setLoading(true);
    deleteOfferImport({ id })
      .then(() => {
        setSuccess(true);
        enqueueSnackbar('Файл удален', {
          variant: 'success',
        });
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setTimeout(() => {
          setSuccess(false);
        }, 200);
        setLoading(false);
      });
  }, []);

  return { fetchDelete, loadingDelete, successDelete };
};
